import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { getActiveBrandPromotion } from '../../../utils/get-active-brand-promotion.js';

const BrandPromotion = ({ brandPromotions =[] , brandName , isClickable , className ,  })=>{
    const { getFormattedLabel  } = useIntl();
    const brand = getActiveBrandPromotion(brandName, brandPromotions);
    // when no brand data render nothing
    if (!brand) {
        return null;
    }
    // get the correct imageUrl (clickable vs default)
    const imageUrl = isClickable ? brand.clickableLogo : brand.logo;
    if (!imageUrl) {
        return null;
    }
    const labelOptions = {
        hideLabelKey: true,
        defaultValue: `${brandName} reseller`,
        labelData: {
            brand: brandName
        }
    };
    const imageAlt = isClickable ? getFormattedLabel('products.brand.promotionLogo.verify', labelOptions) : getFormattedLabel('products.brand.promotionLogo', labelOptions);
    const image = /*#__PURE__*/ React__default.createElement("img", {
        src: imageUrl,
        alt: imageAlt,
        loading: "lazy"
    });
    return /*#__PURE__*/ React__default.createElement("div", {
        className: `brand-promotion ${className ? className : ''}`
    }, (brand === null || brand === void 0 ? void 0 : brand.url) && isClickable ? /*#__PURE__*/ React__default.createElement("a", {
        href: brand.url,
        target: "_blank",
        rel: "noreferrer"
    }, image) : /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, image));
};

export { BrandPromotion };
//# sourceMappingURL=BrandPromotion.js.map
